import { Emit, Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';
import AllocationPercentile from '../questions/allocation-percentile/index.vue';
import AllocationPercentileV2 from '../questions/allocation-percentile-v2/index.vue';
import { TrustAPI } from '@/shared/modules/trust-api';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { EventEmitter } from 'events';
import store from '@/trust-atcs-app/store';
import { ComplianceForm, PartAFormPracticeAreas } from '@/shared/modules/typescript-trustapi-client/models';
import { FormPartAData } from '@/trust-atcs-app/models/form-part-a-data';
import { QuestionType } from '../questions/question-type';

@Options({
  components: {
    AllocationPercentile,
    AllocationPercentileV2
  },
})
export default class FormPartAPracticeAreas extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private formPartAData!: FormPartAData;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Emit('update:isSectionLoading')
  @Emit('validForm')
  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights();
  private loadingContent = false;
  private errorLoadingContent = false;

  private practiceAreasContent: PartAFormPracticeAreas = null as any;
  private validMainQuestions: boolean[] = [];

  created(): void {
    this.loadPracticeAreasContent();
  }

  mounted(): void {
    this.eventCtrl.on('reload-form-a-practicearea-content', this.loadPracticeAreasContent);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-a-practicearea-content', this.loadPracticeAreasContent);
  }

  private async loadPracticeAreasContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartAFormApi?.apiV2PartAFormGetPracticeAreasPost({
        complianceFormId: this.complianceFormA.id,
        updatingKey: this.updatingKey,
      });

      this.practiceAreasContent = resp.data.data as PartAFormPracticeAreas;
      this.formPartAData.practiceAreas = this.practiceAreasContent;
      // Sort this.formPartAData.practiceAreas.atcsMainQuestions.atcsSubQuestions by order number
      this.formPartAData.practiceAreas.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      this.validMainQuestions = this.formPartAData.practiceAreas.atcsMainQuestions.map((q: any) => false);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content');
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  // private onValueChanged(event: any): void {
  //   console.log('onValueChanged-formPart-A', event);
  // }

  private validForm(): boolean {
    return !this.validMainQuestions.includes(false);
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormA(): ComplianceForm {
    return store.getters.getSelectedComplianceFormA;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get QuestionType(): any {
    return QuestionType;
  }
}
